import moment from 'moment';

const MIN_REMAINING_TIME = 30;

function getExpiration(token) {
  let [, payload] = token.split('.');
  payload = JSON.parse(atob(payload));
  return moment.unix(payload.exp).utc();
}

export function tokenNeedsRefresh(token) {
  if (token === null) {
    throw new Error('token cannot be null!');
  }
  const expiration = getExpiration(token);
  return expiration.diff(moment.utc(), 'minutes') <= MIN_REMAINING_TIME;
}



// WEBPACK FOOTER //
// ./src/services/tokenService.js